import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import "../VehiculeForm.css";

const StepFourNeuf = ({ sendData, isActive, onPrevious, onComplete, commonData, submissionError, handleSave }) => {
    const [isSubmitting, setIsSubmitting] = useState(false);

    const [formData, setFormData] = useState({
        // SIGNATURE DU TITULAIRE
        sig_1: null, // "Fait à"
        sig_1_1: null, // "Le" JJ
        sig_1_2: null, // "Le" MM
        sig_1_3: null, // "Le" AAAA
        sig_1_4: '0', // checkbox "Je m'oppose à la réutilisation de mes données personnelles à des fins de prospection commerciale"

        // SIGNATURE DU LOUEUR
        sig_2: null, // "Fait à"
        sig_2_1: null, // "Le" JJ
        sig_2_2: null, // "Le" MM
        sig_2_3: null, // "Le" AAAA
        sig_2_4: '0', // checkbox "Je m'oppose à la réutilisation de mes données personnelles à des fins de prospection commerciale"

        // SIGNATURE DU LOCATAIRE
        sig_3: null, // "Fait à"
        sig_3_1: null, // "Le" JJ
        sig_3_2: null, // "Le" MM
        sig_3_3: null, // "Le" AAAA
        sig_3_4: '0', // checkbox "Je m'oppose à la réutilisation de mes données personnelles à des fins de prospection commerciale"
    });

    useEffect(() => {
        if (!commonData) return;
        // Always merge stepThreeData and stepFourData so loc_0 is preserved
        const stepThree = commonData.stepThreeData || {};
        const stepFour = commonData.stepFourData || {};
        setFormData(prevState => ({
            ...prevState,
            numero_dossier: commonData.numero_dossier,
            statut: commonData.statut,
            vendeur_id: commonData.vendeur_id,
            // Expose loc_0 from step three
            loc_0: stepThree.loc_0,
            // Merge all location data then signature data
            ...stepThree,
            ...stepFour
        }));
    }, [commonData]);

    useEffect(() => {
        if (submissionError) {
            setIsSubmitting(false);
        }
    }, [submissionError]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        
        const finalValue = value.toUpperCase();
        setFormData({
            ...formData,
            [name]: finalValue
        });
    };

    const handleCheckboxChange = (name, checked) => {
        setFormData({
            ...formData,
            [name]: checked ? '1' : '0'
        });
    };

    const handleDateFieldChange = (e, fieldPrefix, part) => {
        const { value } = e.target;
        let newValue = value.replace(/[^0-9]/g, '');
        
        if (part === '1') { // Day
            // Only allow 01-31
            if (newValue.length > 2) newValue = newValue.slice(0, 2);
            if (newValue && parseInt(newValue) > 31) newValue = '31';
            if (newValue && parseInt(newValue) < 1 && newValue.length === 2) newValue = '01';
            // Only add leading zero when field loses focus or has 2 digits
            if (newValue.length === 1 && e.type === 'blur') {
                newValue = '0' + newValue;
            }
        } else if (part === '2') { // Month
            // Only allow 01-12
            if (newValue.length > 2) newValue = newValue.slice(0, 2);
            if (newValue && parseInt(newValue) > 12) newValue = '12';
            if (newValue && parseInt(newValue) < 1 && newValue.length === 2) newValue = '01';
            // Only add leading zero when field loses focus or has 2 digits
            if (newValue.length === 1 && e.type === 'blur') {
                newValue = '0' + newValue;
            }
        } else if (part === '3') { // Year
            // Only allow 4 digit years
            newValue = newValue.slice(0, 4);
            // Ensure year is not in the future
            const currentYear = new Date().getFullYear();
            if (newValue && parseInt(newValue) > currentYear && newValue.length === 4) 
                newValue = currentYear.toString();
        }
        
        setFormData({
            ...formData,
            [`${fieldPrefix}_${part}`]: newValue
        });
    };

    // const handleSubmit = () => {
    //     console.log('Submitting step four data:', formData);
    //     sendData(formData);
    //     setIsSubmitting(true);
    //     if (onComplete) {
    //         console.log('Calling onComplete with form data');
    //         onComplete(formData); 
    //     }
    // };

    const handlePrevious = () => {
        sendData(formData);
        if (onPrevious) onPrevious();
    };

    if (!isActive) return null;

    return (
        <>
            <div className="section">
                <h3>SIGNATURE DU TITULAIRE</h3>
                <div className="form-group">
                    <label htmlFor="sig_1">FAIT À:</label>
                    <input
                        type="text"
                        id="sig_1"
                        name="sig_1"
                        value={formData.sig_1 || ''}
                        onChange={handleInputChange}
                        pattern="[A-Za-zÀ-ÿ\s\-']+"
                        title="Veuillez entrer un nom de ville valide"
                        maxLength={100}
                        required
                    />
                </div>
    
                <div className="form-group">
                    <label>LE:</label>
                    <div className="date-input-group">
                        <div className="date-field">
                            <label htmlFor="sig_1_1">JOUR</label>
                            <input
                                type="text"
                                id="sig_1_1"
                                name="sig_1_1"
                                value={formData.sig_1_1 || ''}
                                onChange={(e) => handleDateFieldChange(e, 'sig_1', '1')}
                                onBlur={(e) => handleDateFieldChange(e, 'sig_1', '1')}
                                placeholder="JJ"
                                maxLength="2"
                                required
                            />
                        </div>
                        <div className="date-field">
                            <label htmlFor="sig_1_2">MOIS</label>
                            <input
                                type="text"
                                id="sig_1_2"
                                name="sig_1_2"
                                value={formData.sig_1_2 || ''}
                                onChange={(e) => handleDateFieldChange(e, 'sig_1', '2')}
                                onBlur={(e) => handleDateFieldChange(e, 'sig_1', '2')}
                                placeholder="MM"
                                maxLength="2"
                                required
                            />
                        </div>
                        <div className="date-field">
                            <label htmlFor="sig_1_3">ANNÉE</label>
                            <input
                                type="text"
                                id="sig_1_3"
                                name="sig_1_3"
                                value={formData.sig_1_3 || ''}
                                onChange={(e) => handleDateFieldChange(e, 'sig_1', '3')}
                                placeholder="AAAA"
                                maxLength="4"
                                required
                            />
                        </div>
                    </div>
                </div>

                 <div className="checkbox-group">
                    <input
                        type="checkbox"
                        id="sig_1_5"
                        name="sig_1_5"
                        checked={formData.sig_1_5 === '1'}
                        onChange={(e) => handleCheckboxChange('sig_1_5', e.target.checked)}
                    />
                    <label htmlFor="sig_1_5">
                        JE SUIS INFORMÉ(E) QUE POUR CIRCULER AVEC CE VEHICULE JE SUIS DANS L&apos;OBLIGATION DE L&apos;ASSURER PRÉALABLEMENT (ARTICLES L.324-1 ET L.324-2 DU CODE DE LA ROUTE).
                    </label>
                </div> 

                <div className="checkbox-group">
                    <input
                        type="checkbox"
                        id="sig_1_4"
                        name="sig_1_4"
                        checked={formData.sig_1_4 === '1'}
                        onChange={(e) => handleCheckboxChange('sig_1_4', e.target.checked)}
                    />
                    <label htmlFor="sig_1_4">
                        JE M&apos;OPPOSE À LA RÉUTILISATION DE MES DONNÉES PERSONNELLES À DES FINS DE PROSPECTION COMMERCIALE
                    </label>
                </div>
            </div>
    
            <div className="section">
                <h3>SIGNATURE DU LOUEUR</h3>
                <div className="form-group">
                    <label htmlFor="sig_2">FAIT À:</label>
                    <input
                        type="text"
                        id="sig_2"
                        name="sig_2"
                        value={formData.sig_2 || ''}
                        onChange={handleInputChange}
                        pattern="[A-Za-zÀ-ÿ\s\-']+"
                        title="Veuillez entrer un nom de ville valide"
                        maxLength={100}
                        required={formData.loc_0 === '1'} 
                    />
                </div>
    
                <div className="form-group">
                    <label>LE:</label>
                    <div className="date-input-group">
                        <div className="date-field">
                            <label htmlFor="sig_2_1">JOUR</label>
                            <input
                                type="text"
                                id="sig_2_1"
                                name="sig_2_1"
                                value={formData.sig_2_1 || ''}
                                onChange={(e) => handleDateFieldChange(e, 'sig_2', '1')}
                                onBlur={(e) => handleDateFieldChange(e, 'sig_2', '1')}
                                placeholder="JJ"
                                maxLength="2"
                                required={formData.loc_0 === '1'}
                            />
                        </div>
                        <div className="date-field">
                            <label htmlFor="sig_2_2">MOIS</label>
                            <input
                                type="text"
                                id="sig_2_2"
                                name="sig_2_2"
                                value={formData.sig_2_2 || ''}
                                onChange={(e) => handleDateFieldChange(e, 'sig_2', '2')}
                                onBlur={(e) => handleDateFieldChange(e, 'sig_2', '2')}
                                placeholder="MM"
                                maxLength="2"
                                required={formData.loc_0 === '1'}
                            />
                        </div>
                        <div className="date-field">
                            <label htmlFor="sig_2_3">ANNÉE</label>
                            <input
                                type="text"
                                id="sig_2_3"
                                name="sig_2_3"
                                value={formData.sig_2_3 || ''}
                                onChange={(e) => handleDateFieldChange(e, 'sig_2', '3')}
                                placeholder="AAAA"
                                maxLength="4"
                                required={formData.loc_0 === '1'}
                            />
                        </div>
                    </div>
                </div>
    
                <div className="checkbox-group">
                    <input
                        type="checkbox"
                        id="sig_2_4"
                        name="sig_2_4"
                        checked={formData.sig_2_4 === '1'}
                        onChange={(e) => handleCheckboxChange('sig_2_4', e.target.checked)}
                    />
                    <label htmlFor="sig_2_4">
                        JE M&apos;OPPOSE À LA RÉUTILISATION DE MES DONNÉES PERSONNELLES À DES FINS DE PROSPECTION COMMERCIALE
                    </label>
                </div>
            </div>
    
            <div className="section">
                <h3>SIGNATURE DU LOCATAIRE</h3>
                <div className="form-group">
                    <label htmlFor="sig_3">FAIT À:</label>
                    <input
                        type="text"
                        id="sig_3"
                        name="sig_3"
                        value={formData.sig_3 || ''}
                        onChange={handleInputChange}
                        pattern="[A-Za-zÀ-ÿ\s\-']+"
                        title="Veuillez entrer un nom de ville valide"
                        maxLength={100}
                        required={formData.loc_0 === '1'} 
                    />
                </div>
    
                <div className="form-group">
                    <label>LE:</label>
                    <div className="date-input-group">
                        <div className="date-field">
                            <label htmlFor="sig_3_1">JOUR</label>
                            <input
                                type="text"
                                id="sig_3_1"
                                name="sig_3_1"
                                value={formData.sig_3_1 || ''}
                                onChange={(e) => handleDateFieldChange(e, 'sig_3', '1')}
                                onBlur={(e) => handleDateFieldChange(e, 'sig_3', '1')}
                                placeholder="JJ"
                                maxLength="2"
                                required={formData.loc_0 === '1'}
                            />
                        </div>
                        <div className="date-field">
                            <label htmlFor="sig_3_2">MOIS</label>
                            <input
                                type="text"
                                id="sig_3_2"
                                name="sig_3_2"
                                value={formData.sig_3_2 || ''}
                                onChange={(e) => handleDateFieldChange(e, 'sig_3', '2')}
                                onBlur={(e) => handleDateFieldChange(e, 'sig_3', '2')}
                                placeholder="MM"
                                maxLength="2"
                                required={formData.loc_0 === '1'}
                            />
                        </div>
                        <div className="date-field">
                            <label htmlFor="sig_3_3">ANNÉE</label>
                            <input
                                type="text"
                                id="sig_3_3"
                                name="sig_3_3"
                                value={formData.sig_3_3 || ''}
                                onChange={(e) => handleDateFieldChange(e, 'sig_3', '3')}
                                placeholder="AAAA"
                                maxLength="4"
                                required={formData.loc_0 === '1'}
                            />
                        </div>
                    </div>
                </div>
    
                <div className="checkbox-group">
                    <input
                        type="checkbox"
                        id="sig_3_4"
                        name="sig_3_4"
                        checked={formData.sig_3_4 === '1'}
                        onChange={(e) => handleCheckboxChange('sig_3_4', e.target.checked)}
                    />
                    <label htmlFor="sig_3_4">
                        JE M&apos;OPPOSE À LA RÉUTILISATION DE MES DONNÉES PERSONNELLES À DES FINS DE PROSPECTION COMMERCIALE
                    </label>
                </div>
            </div>
    
            <div className="button-container">
                <button type="button" className="prev-button" onClick={handlePrevious}>PRÉCÉDENT</button>
                <button type="button" className="save-button" onClick={() => handleSave(formData)}>ENREGISTRER</button>
                <button
                    type="button"
                    onClick={async () => {
                        try {
                            await handleSave(formData); // Enregistre les données
                            onComplete(); // Passe à la Step 5
                        } catch (error) {
                            console.error("Erreur lors de l'enregistrement :", error);
                            alert("Une erreur est survenue lors de l'enregistrement. Veuillez réessayer.");
                        }
                    }}
                    className="finish-button"
                    disabled={isSubmitting}
                >
                    {isSubmitting ? "TRAITEMENT EN COURS..." : "TERMINER"}
                </button>
            </div>
            
            {submissionError && (
                <div className="error-message">
                    {submissionError}
                </div>
            )}
        </>
    );
};

StepFourNeuf.propTypes = {
    sendData: PropTypes.func.isRequired,
    isActive: PropTypes.bool,
    onPrevious: PropTypes.func,
    onComplete: PropTypes.func,
    commonData: PropTypes.object,
    submissionError: PropTypes.string,
    handleSave: PropTypes.func.isRequired
};

export default StepFourNeuf;